import { filter, Subject, Subscription } from "rxjs";
import { computed } from "../decorators/computed";
import { PlatformEvent } from "./platform-event";
import { WS } from "./ws";
import { Live } from "./live";

export type Notification = {
  type: "success" | "danger" | "warning" | "neutral";
  msg: string;
};

const NOTIFICATION_DISPLAY_TIMEOUT = 5000;

export class XApp {
  notifications$: Subject<Notification | null>;
  timeoutId: NodeJS.Timeout | null = null;

  /**
   * WebSocket
   */
  private readonly wss$ = new Subject<PlatformEvent>();
  private readonly inputWss$ = new Subject<
    Omit<PlatformEvent, "committedAt" | "committedBy">
  >();
  private readonly ws: WS;
  private readonly sub: Subscription;

  constructor(
    accessToken: string,
    private onFragmentUpdate: (args: {
      typename: string;
      id: string | number;
    }) => void
  ) {
    this.ws = new WS(accessToken, this.wss$, this.inputWss$);
    this.ws.connnect();
    this.notifications$ = new Subject();

    this.sub = this.graphql$.subscribe((platformEvent) => {
      onFragmentUpdate({
        typename: platformEvent.entityType,
        id: platformEvent.entityId,
      });
    });
  }

  destroy() {
    this.ws.close("X-App unmounted");
    this.sub.unsubscribe();
  }

  next(notification: Notification) {
    this.timeoutId && clearTimeout(this.timeoutId);
    this.notifications$.next(notification);
    this.timeoutId = setTimeout(() => {
      this.notifications$.next(null);
    }, NOTIFICATION_DISPLAY_TIMEOUT);
  }

  @computed
  get graphql$() {
    return this.wss$.pipe(
      filter((platformEvent) => platformEvent.topic === "graphql")
    );
  }

  @computed
  get live$() {
    return new Live(this.wss$, this.inputWss$);
  }
}
